// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__uAQb-","location":"Header_location__1CdGX"};